export function getClientesOptions(array) {
  let salida = [];
  array.map((p) => {
    salida = [...salida, { value: p.clienteID, text: p.nombre }];
  });

  return salida;
}
